<template>
  <object class="icon-def" :class="props.class" type="image/svg+xml" :data="nameValue" style="pointer-events: none;"></object>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  class: {
    type: String,
    default: ""
  }
})
const nameValue = computed(() => {
    return '/icons/'+ props.name +'.svg'
  })
</script>



